import { Action, ActionReducer } from '@ngrx/store';

import { ActionConstants } from '../constants/action.constants';

// Common object should be object with uniqueId as identifier and getUniqueId() method
export interface CommonObjectListState {
	commonObjectList: Array<any>;
}

export const initialState: CommonObjectListState = {
	commonObjectList: []
};

export function createReducerWithName(name: string): ActionReducer<any, Action> {
	if (!name) {
		throw new Error('Error in createReducerWithName: name cannot be empty!');
	}

	name = name.toUpperCase();

	return function create(state = initialState, action: any): CommonObjectListState {
		switch (action.type) {
			case ActionConstants.ADD_ONE + name: {
				return {
					...state,
					commonObjectList: [...state.commonObjectList, action.payload]
				};
			}

			case ActionConstants.ADD_MANY + name: {
				return {
					...state,
					commonObjectList: [
						...state.commonObjectList.map(object => {
							const updated = action.payload.find(
								updatedObject => updatedObject.uniqueId === object.uniqueId
							);
							return updated ? updated : object;
						}),
						...action.payload.filter(
							object => {
								return state.commonObjectList.length
									? !state.commonObjectList.find(portfolio => portfolio.uniqueId === object.uniqueId)
									: true;
							}
						)
					]
				};
			}

			case ActionConstants.UPDATE_MANY + name: {
				return {
					...state,
					commonObjectList: state.commonObjectList.map(object => {
						const updated = action.payload.find(
							updatedObject => updatedObject.uniqueId === object.uniqueId
						);
						return updated ? updated : object;
					})
				};
			}

			case ActionConstants.REMOVE_ONE + name: {
				return {
					...state,
					commonObjectList: state.commonObjectList.filter(object => {
						return object.uniqueId !== action.payload.uniqueId;
					})
				};
			}

			case ActionConstants.LOAD_ALL + name: {
				return {
					...state,
					commonObjectList: action.payload
				};
			}

			default: {
				return state;
			}
		}
	};
}

export const getCommonObjectList = (state: CommonObjectListState) => state.commonObjectList;
